import { render } from "./LayoutPage.vue?vue&type=template&id=03ef7c41&scoped=true"
import script from "./LayoutPage.vue?vue&type=script&lang=js"
export * from "./LayoutPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ef7c41"]])

export default __exports__